import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import CorporateSection from '../Components/Corporate/Corporate'; // renamed import
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function CorporatePage() { // renamed component
    return (
        <>
        <Helmet>
                <title>Corporate Veg Catering in Coimbatore | Office Meals by Tickling Tummy</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, providing healthy corporate catering and daily office lunch delivery in R.S. Puram." />
                <meta name="keywords" content="Corporate catering Coimbatore, Office lunch Coimbatore, Homemade vegetarian meals, Healthy office meals Coimbatore, Veg snack boxes, Corporate event food" />
                <link rel="canonical" href="https://ticklingtummy.com/corporate" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Corporate Veg Catering in Coimbatore | Office Meals by Tickling Tummy" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, providing healthy corporate catering and daily office lunch delivery in R.S. Puram." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/corporate-catering-food-service-coimbatore.jpg" />
                <meta property="og:url" content="https://ticklingtummy.com/corporate" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Corporate Veg Catering in Coimbatore | Office Meals by Tickling Tummy" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, providing healthy corporate catering and daily office lunch delivery in R.S. Puram." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/corporate-catering-food-service-coimbatore.jpg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  },
  {
    "@type": "ListItem",
    "position": 2,
    "name": "Corporate Catering",
    "item": "https://ticklingtummy.com/corporate"
  }
]
        }, null, 2)}
        </script>

            <HeaderOne />
            <CorporateSection />
            <Footer />
        </>
    );
}

export default CorporatePage;
